import { render, staticRenderFns } from "./ViewLesson.vue?vue&type=template&id=42b72480&scoped=true&"
import script from "./ViewLesson.vue?vue&type=script&lang=js&"
export * from "./ViewLesson.vue?vue&type=script&lang=js&"
import style0 from "./ViewLesson.vue?vue&type=style&index=0&id=42b72480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b72480",
  null
  
)

export default component.exports